(function() {
  $(function() {
    return $('.navbar .dropdown > a').click(function() {
      return location.href = this.href;
    });
  });

}).call(this);

//# sourceMappingURL=compiled.js.map
